module.exports = __webpack_public_path__ + "img/id-card@2x.e2bd6cd8.png";